module.exports = __webpack_public_path__ + "assets/fb4b196e3141225bfeb1ec92f3b2866e.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/Bet_4.mp3
 ** module id = 333
 ** module chunks = 0
 **/